export const getExtension = (fullName: string | undefined, fileName: string) => fullName?.replace(fileName, '');
